<template>
    <div
        v-if="item.readonly"
        :key="inputKey + 'readonly'"
        class="input-box"
        :class="[item.name, ...className]"
    >
        <slot name="custom-title"></slot>
        <p v-if="showTitle" class="title" v-html="item.title"></p>
        <input
            v-if="validatePhone && item.type === 'tel'"
            :type="item.type"
            :value="$ft.formatPhone(item.value)"
            readonly
            :name="item.name"
        />
        <input
            v-else
            :type="item.type"
            :value="item.value"
            readonly
            :name="item.name"
        />
    </div>
    <v-input
        v-else
        :key="inputKey"
        class="input-box"
        :className="[item.name, ...className]"
        :tag="item.tag || 'input'"
        :name="item.name"
        :type="item.type"
        :placeholder="showTitle ? '' : item.placeholder || ''"
        :value="item.defaultValue || ''"
        :required="item.required"
        :maxlength="item.maxlength || 100"
        :validateConfig="item.validateConfig || {}"
        :otherOption="item.otherOption || {}"
        :changeLabelPos="changeLabelPos"
    >
        <slot name="custom-title"></slot>
        <p v-if="showTitle" class="title" v-html="item.title"></p>
    </v-input>
</template>

<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import vInput from './v-input.vue';

export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        showTitle: {
            type: Boolean,
            default: false
        },
        changeLabelPos: {
            type: Boolean,
            default: true
        },
        className: {
            type: Array,
            default: () => ([])
        }
    },
    data: function() {
        return {
            inputKey: this.item.name
        };
    },
    computed: {
        ...mapState(usePageStore, {
            page: store => store.page
        }),
        validatePhone({ page }) {
            return !(page.site && page.site.validatePhone === false);
        },
        validateConfig() {
            return this.item.validateConfig || {};
        }
    },
    watch: {
        validateConfig(val, oldVal) {
            if (val && oldVal && val.validatePhone !== oldVal.validatePhone) {
                this.inputKey = this.inputKey + '-' + Date.now();
                this.validatePhone = val.validatePhone;
            }
        }
    },
    created() {
        if (
            this.validateConfig &&
            this.validateConfig.validatePhone !== undefined
        ) {
            this.validatePhone = this.validateConfig.validatePhone;
        }
    },
    components: {
        vInput
    }
};
</script>
